/* eslint-disable */

import type { ExpensesLang } from "./types/ExpensesLang";

let data: ExpensesLang | undefined;

export type { ExpensesLang };

export default function ExpensesLangFactory(): ExpensesLang {
  if (!data) {
    throw new Error("Trying to load a language in the main bundle before the language bundle is loaded");
  }
  return data;
}

export let setExpensesLang = (newLang: string) => {
  if (newLang === "en-GB") {
      return import(/* webpackChunkName: "en-GB.locale" */ "./en-GB/ExpensesLangDef").then(({ ExpensesLangDef }) => {
      data = ExpensesLangDef;
    });
  } else if (newLang === "sv-SE") {
      return import(/* webpackChunkName: "sv-SE.locale" */ "./sv-SE/ExpensesLangDef").then(({ ExpensesLangDef }) => {
      data = ExpensesLangDef;
    });
  } else if (newLang === "en-SE") {
      return import(/* webpackChunkName: "en-SE.locale" */ "./en-SE/ExpensesLangDef").then(({ ExpensesLangDef }) => {
      data = ExpensesLangDef;
    });
  } else if (newLang === "ky-KG") {
      return import(/* webpackChunkName: "ky-KG.locale" */ "./ky-KG/ExpensesLangDef").then(({ ExpensesLangDef }) => {
      data = ExpensesLangDef;
    });
  }
  else {
    throw new Error("Unsupported language/culture " + newLang);
  }
};

